<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="JOB_CATEGORY_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            label="대상직군"
            name="jobCategoryCd"
            v-model="searchParam.jobCategoryCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="평가기간"
            name="assessmentDates"
            v-model="searchParam.assessmentDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="평가구분"
            v-model="searchParam.ramAssessTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="직군별 위험성평가 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      selection="single"
      rowKey="ramRiskAssessmentPlanId"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskOfficeLoadPop",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        ramTechniqueCd: null,
        jobCategoryCd: null,
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: "auto",
    },
  },
  data() {
    return {
      searchParam: {
        plantCd: null,
        assessmentDates: [],
        ramAssessTypeCd: null,
        ramTechniqueCd: null, // 사무직
        officeCompleteFlag: "Y", // 완료된 평가만
        jobCategoryCd: null,
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "assessmentName",
            field: "assessmentName",
            label: "평가명",
            align: "left",
            style: "width:250px",
            sortable: true,
          },
          {
            name: 'jobCategoryName',
            field: 'jobCategoryName',
            label: '대상직군',
            align: "center",
            style: "width:80px",
            sortable: true,
          },
          {
            name: "assessmentDate",
            field: "assessmentDate",
            label: "평가기간",
            align: "center",
            style: "width:180px",
            sortable: true,
          },
          {
            name: "ramAssessTypeName",
            field: "ramAssessTypeName",
            label: "평가구분",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "deptName",
            field: "deptName",
            label: "평가부서",
            align: "left",
            style: "width:200px",
            sortable: true,
          },
          {
            name: "officeCompleteFlagName",
            field: "officeCompleteFlagName",
            label: "진행상태",
            align: "center",
            style: "width:80px",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "LBLREGISTER",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ],
        height: "600px",
        data: [],
      },
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // url setting
      this.listUrl = selectConfig.ram.assessPlan.list.url;
      if (this.popupParam.ramTechniqueCd) this.searchParam.ramTechniqueCd = this.popupParam.ramTechniqueCd;
      if (this.popupParam.jobCategoryCd) this.searchParam.jobCategoryCd = this.popupParam.jobCategoryCd;
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      this.$emit("closePopup", [row]);
    },
  },
};
</script>
